import useSWR from 'swr'

import {
  AuthenticationCredentialFetcher,
  CreateRefreshToken,
  GetAccountAvailabilityFetcher,
  GetCurrentUserFetcher,
  GetUsersFetcher,
  GetUserVehicles,
  InviteUserFetcher,
  LoginFetcher,
  OtpVerifyFetcher,
  PolicyFetcher,
  SignUpFetcher,
  SignUpV2Fetcher,
  UpdateCurrentTenantInvoiceFetcher,
  UpdateCurrentUserFetcher,
  UpdateOnboardingFetcher,
  ForgotPasswordFetcher,
  ConfirmSignUpFetcher,
  AuthenticationMethodFetcher,
  ConfirmForgotPasswordFetcher,
  ResendEmailConfirmationFetcher,
  GetCompanyDocumentPreSignedUrlFetcher,
  SaveCompanyDocumentFetcher,
  CompleteCompanyDocumentFetcher,
  GetUploadTenantDocumentPresignedUrlFetcher,
  GetUploadedTenantDocumentExtractedFetcher,
} from './TenantServiceFetchers'

export enum TenantServicePath {
  GetCurrentTenant = '/carrier/current',
  GetCurrentUser = '/carrier/users/current',
  GetAccountAvailability = '/users/accountAvailability',
  InviteUser = '/carrier/users/invite',
  Login = '/carrier/users/login',
  OtpVerify = '/carrier/users/loginVerify',
  Policy = '/carrier/users/policy',
  RefreshToken = '/users/refreshToken',
  SignUp = '/carrier/users/signup',
  SignUpV2 = '/carrier/users/signup',
  UpdateOnboarding = '/carrier/onboarding',
  Users = '/carrier/users',
  Vehicles = '/carrier/vehicles',
  Invoice = '/carrier/invoice',
  AuthenticationCredential = '/users/authenticationCredential',
  ForgotPassword = '/users/forgotPassword',
  ConfirmSignup = '/users/confirmSignup',
  AuthenticationMethod = '/users/authenticationMethod',
  ConfirmForgotPassword = '/users/confirmForgotPassword',
  ResendEmailConfirmation = '/users/resendCode',
  GetCompanyDocumentPreSignedUrl = '/carrier/documents/presignedUrl',
}

export default {
  getCurrentTenant: (revalidateOnMount = true, revalidateIfStale = false) =>
    useSWR(TenantServicePath.GetCurrentTenant, GetCurrentUserFetcher, {
      revalidateOnMount,
      revalidateIfStale,
    }),
  getCurrentUser: (revalidateOnMount = true, revalidateIfStale = true) =>
    useSWR(TenantServicePath.GetCurrentUser, GetCurrentUserFetcher, {
      revalidateOnMount,
      revalidateIfStale,
    }),
  getUsers: (query: string, revalidateOnMount = true, revalidateIfStale = true) =>
    useSWR([TenantServicePath.Users, query], GetUsersFetcher, {
      revalidateOnMount,
      revalidateIfStale,
    }),
  getVehicles: (query: string, revalidateOnMount = true) =>
    useSWR([TenantServicePath.Vehicles, query], GetUserVehicles, {
      revalidateOnMount,
    }),
  updateOnboarding: (data: unknown, revalidateOnMount = false) => {
    return useSWR([TenantServicePath.UpdateOnboarding, data], data ? UpdateOnboardingFetcher : null, {
      revalidateOnMount,
    })
  },
  updateFavRoute: (data?: unknown, revalidateOnMount = false) => {
    return useSWR(['/carrier/favoriteRoute', data], data ? UpdateOnboardingFetcher : null, {
      revalidateOnMount,
      revalidateIfStale: false,
    })
  },
  GetAccountAvailabilityFetcher,
  CreateRefreshToken,
  InviteUserFetcher,
  LoginFetcher,
  OtpVerifyFetcher,
  PolicyFetcher,
  SignUpFetcher,
  SignUpV2Fetcher,
  UpdateCurrentTenantInvoiceFetcher,
  UpdateCurrentUserFetcher,
  AuthenticationCredentialFetcher,
  ForgotPasswordFetcher,
  ConfirmSignUpFetcher,
  AuthenticationMethodFetcher,
  ConfirmForgotPasswordFetcher,
  ResendEmailConfirmationFetcher,
  GetCompanyDocumentPreSignedUrlFetcher,
  SaveCompanyDocumentFetcher,
  CompleteCompanyDocumentFetcher,
  GetUploadTenantDocumentPresignedUrlFetcher,
  GetUploadedTenantDocumentExtractedFetcher,
}
